import { render, staticRenderFns } from "./helpCard.vue?vue&type=template&id=10f4597e&scoped=true&"
import script from "./helpCard.vue?vue&type=script&lang=js&"
export * from "./helpCard.vue?vue&type=script&lang=js&"
import style0 from "./helpCard.vue?vue&type=style&index=0&id=10f4597e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f4597e",
  null
  
)

export default component.exports